var _rect, _path, _line, _line2, _line3, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    stroke: "black",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 216,
    width: 192,
    height: 16,
    fill: "black",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 216 L128 40 L192 216 Z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 176,
    x2: 168,
    y2: 200
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 152,
    x2: 160,
    y2: 104
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 120,
    x2: 152,
    y2: 56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 64,
    width: 48,
    height: 16,
    fill: "black",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 24            c4 8 4 16 -4 24            c8 -4 16 -4 24 4            c-4 -8 -4 -16 4 -24            c-8 4 -16 4 -24 -4            Z",
    fill: "black",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasNew);
export default __webpack_public_path__ + "static/media/gas_new.b8ed57fccde362897b5d1eb4e085d313.svg";
export { ForwardRef as ReactComponent };